module.exports = __webpack_public_path__ + "static/media/11-aermel_schuhe_brille.f2f4b139.jpg";